import { CalendarSectionsEnum } from '../enums/calendar-sections-enum'

export const calendarSections: CalendarSectionsEnum[] = [
  CalendarSectionsEnum.events,
  CalendarSectionsEnum.bookings,
  CalendarSectionsEnum.availability,
]

export const staticMinutes = [5, 10, 15, 20, 30, 45, 60, 90, 120]

export const greenwichTimeZone = 'Etc/GMT'
